module.exports = __webpack_public_path__ + "static/img/icon_jingyin_weidianji_40px.6682b5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_jingyin_weidianji_40px.png
// module id = O0w+
// module chunks = 136